import React, { useState } from 'react'
import { Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { DF_LO0003Context } from './context'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import GridFooter from './Grid/GridFooter'
import {
  fnGetValueByKey
} from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'

const DF_LO0003 = () => {  
  console.log('🤖 %cTransação [DF_LO0003]', 'color:green')  
  
  const { userProfile, isModalPage } = useSelector(state => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage
  }))

  const [isLoading, setisLoading] = useState(false)

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState('')
  const [filteredData, setFilteredData] = useState([])

  return (
    <React.Fragment>
      <DF_LO0003Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData
        }}
      >
        <div style={{ padding: isModalPage && '0px', overflow: isModalPage && 'hidden'}}  className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader context={DF_LO0003Context} />
            <GridBody />
          </Container>          
        </div>

        {!isModalPage && <>
          <GridFooter />
        </>}
        
      </DF_LO0003Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(DF_LO0003)
